import { Component, OnInit, Input } from "@angular/core";
import { SaleOrder } from "../../../models/saleOrder";
import { Methods } from "../../../shared/methods";

declare const $: any;

@Component({
  selector: 'app-addresses',
  templateUrl: './addresses.component.html',
  styleUrls: ['./addresses.component.css']
})
export class AddressesComponent implements OnInit {
  public mtds: Methods = new Methods();
  @Input() edit = true;
  @Input() locations: Array<any> = [];
  @Input() userLocations: Array<any> = [];
  @Input() so: SaleOrder;

  constructor() {}

  ngOnInit() {
    // console.log(this.so);
  }

  selectLocationFrom() {
    console.log(this.so.shipfromlocation_id);
    console.log(this.locations);

    if (
      this.so.shipfromlocation_id !== "new" &&
      this.so.shipfromlocation_id !== "other" &&
      this.so.shipfromlocation_id !== "headq"
    ) {
      for (let location of this.locations) {
        if (this.so.shipfromlocation_id == location.id) {
          this.so.shipfromcompany = location.companyLinked.name;
          this.so.shipfromcontact = location.contactName;
          this.so.shipfromemail = location.email;
          // this.so.shipfromfax = location.
          this.so.shipfromphone = location.phone;
          this.so.shipfromaddress1 = location.address;
          this.so.shipfromaddress2 = location.address2;
          this.so.shipfromcity = location.city;
          this.so.shipfromstate = location.colonia;
          this.so.shipfromcountry = location.country;
          this.so.shipfrompostalcode = location.zipCode;
          break;
        }
      }
    } else if (this.so.shipfromlocation_id == "headq") {
      console.log(this.so);
      this.so.shipfromcompany = this.so.contactcompany;
      this.so.shipfromcontact = this.so.contactcontact;
      this.so.shipfromemail = this.so.contactemail;
      this.so.shipfromfax = this.so.contactphone;
      this.so.shipfromphone = this.so.contactfax;
      this.so.shipfromaddress1 = this.so.contactaddress1;
      this.so.shipfromaddress2 = this.so.contactaddress2;
      this.so.shipfromcity = this.so.contactcity;
      this.so.shipfromstate = this.so.contactstate;
      this.so.shipfromcountry = this.so.contaccountry;
      this.so.shipfrompostalcode = this.so.contactpostalcode;
    }
  }

  selectLocatioTo() {
    console.log(this.so.shiptolocation_id);
    console.log(this.userLocations);

    if (
      this.so.shiptolocation_id !== "new" &&
      this.so.shiptolocation_id !== "other"
    ) {
      for (let location of this.userLocations) {
        if (this.so.shiptolocation_id == location.id) {
          this.so.shiptocompany = location.companyLinked.name;
          this.so.shiptocontact = location.contactName;
          this.so.shiptoemail = location.email;
          // this.so.shiptofax = location.
          this.so.shiptophone = location.phone;
          this.so.shiptoaddress1 = location.address;
          this.so.shiptoaddress2 = location.address2;
          this.so.shiptocity = location.city;
          this.so.shiptostate = location.colonia;
          this.so.shiptocountry = location.country;
          this.so.shiptopostalcode = location.zipCode;
          break;
        }
      }
    }
  }
}